import { getLanguageCode, languageToi18nCode } from "@pandas/core-ui";
import { IconChevronDown, IconChevronRight } from "@tabler/icons-react";
import { useLocation, useNavigate } from "@tanstack/react-router";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "../../store";

export default function LanguageSwitcher() {
	const { t, i18n } = useTranslation();
	const config = useStore((state) => state.config);
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const languageSwitchSelectorRef = useRef<HTMLDivElement>(null);
	const [show, setShow] = useState(false);

	const changeLanguage = (lng: string) => {
		const canonical = getLanguageCode(lng);
		const pathParts = pathname.split("/");
		pathParts[1] = canonical;
		navigate({ to: pathParts.join("/"), search: (prev) => prev, replace: true });
	};

	return (
		<div
			className="text-black text-base font-semibold flex justify-between text-bold px-4 my-3 py-2 w-full cursor-pointer"
			onClick={() => setShow(!show)}
		>
			{t("NavigationBar.Language")}
			<span className="flex items-center uppercase">
				{i18n.language.split("-")[0]}
				{show ? <IconChevronDown size={18} /> : <IconChevronRight size={18} />}
			</span>
			{show && (
				<div className="absolute right-8">
					<div
						className="rounded-lg p-3 mt-8 w-60 shadow-md bg-white ring-1 ring-black ring-opacity-5"
						ref={languageSwitchSelectorRef}
					>
						{config &&
							config.partnerSettings.languages.map((language) => {
								const i18nCode = languageToi18nCode(language);
								return (
									<React.Fragment key={language}>
										<div
											className="pl-6 pb-4 pt-4 text-black text-base select-none font-semibold block px-4 py-2 cursor-pointer rounded-md hover:bg-grey-100"
											onClick={() => {
												if (i18nCode) changeLanguage(i18nCode);
											}}
										>
											{language}
										</div>
									</React.Fragment>
								);
							})}
					</div>
				</div>
			)}
		</div>
	);
}
